<template>
  <div>
    <v-row>
      <v-col cols="12" md="10">
        <v-data-table
              v-model="selected"
              :headers="headerTable"
              :items="mandos"
              item-key="numEmpTitular"
              disable-sort
              dense
              :footer-props="footerProps"
              :items-per-page="10"
              :hide-default-footer="hideFooter"
              :loading="loading"
              loading-text="Cargando datos..."
              class="elevation-2"
        >
          <template v-slot:top>
            <v-row justify="space-between">
              <v-col cols="6" class="ml-6">
                Mandos superiores registrados para autorizar justificantes.
              </v-col>
              <v-col cols="2">
                <v-tooltip bottom activator="#btn-add">
                  <span>Registrar mando</span>
                </v-tooltip>
                <v-btn id="btn-add" icon @click="showFind = true">
                  <v-icon>mdi-account-plus-outline</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </template>

          <template v-slot:item.vigenciaIni="{ item }">
            {{ formatFec(item.vigenciaIni) }}
          </template>
          <template v-slot:item.vigenciaFin="{ item }">
            {{ formatFec(item.vigenciaFin) }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon
              small
              @click="showConfirmar(item)"
            >
              mdi-trash-can-outline
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <dialog-find-empleado :show.sync="showFind" @selected="selectedEmpleado($event)"></dialog-find-empleado>

    <dialog-message :show.sync="hndDlg.showDialog" :color="hndDlg.colorDlg" :title="hndDlg.titleDlg">
      {{ hndDlg.mensaje }}
    </dialog-message>

    <dialog-confirmar :show="showDlgConfirmar" @selected="onConfirmar($event)">
      {{ mensajeConfirmar }}
    </dialog-confirmar>
  </div>
</template>

<script>
import serv from './mandoAutJustiServ.js';
import hndDlg, {showError} from '@/components/dialogs/DialogHandler.js'
import DialogMessage from '@/components/dialogs/DialogMessage.vue';
import DialogFindEmpleado from '@/components/dialogs/DialogFindEmpleado.vue';
import DialogConfirmar from "@/components/dialogs/DialogConfirmar.vue";

export default {
  components: {
    DialogMessage,
    DialogFindEmpleado,
    DialogConfirmar
  },

  data() {
    return {
      mandos: [],
      selected: [],
      numEmpDelete: 0,
      headerTable: [
        { text: 'Apellido Pat.', value: 'apellidoPat', class: "accent white--text"},
        { text: 'Apellido Mat.', value: 'apellidoMat', class: "accent white--text"},
        { text: 'Nombre', value: 'nombres', class: "accent white--text"},
        { text: 'Del', value: 'vigenciaIni', class: "accent white--text"},
        { text: 'Al', value: 'vigenciaFin', class: "accent white--text"},
        { text: 'Registró', value: 'usuario', class: "accent white--text"},
        { text: 'Ver', value: 'actions', class: "accent white--text"},
      ],
      footerProps: {
        disableItemsPerPage: true,
      },
      loading: false,
      hndDlg,
      overlay: false,
      showFind: false,
      showDlgConfirmar: false,
      mensajeConfirmar: ""
    }
  },

  computed: {
    hideFooter() {
      return this.mandos.length < 10;
    }
  },

  methods: {
    async selectedEmpleado(emp) {
      this.overlay = true;
      try {
        await serv.saveMandoAut(emp.numEmpleado);
        this.overlay = false;
        this.loadMandos();
      }catch(error) {
        this.overlay = false;
        this.handleError(error, "No se pudo guardar el registro.")
      }
    },

    loadMandos() {
      let self = this;
      serv.getMandosAut()
      .then(response => {
        self.mandos = response;
      })
    },

    handleError(error, mensaje) {
      if (error.response) {
        this.hndDlg = showError(error.response.data.mensaje);
      } else {
        console.log(error);
        this.hndDlg = showError(mensaje);
      }
    },

    showConfirmar(item) {
      this.numEmpDelete = item.numEmpTitular;
      this.mensajeConfirmar = `¿Quitar el registro de ${item.nombres} ${item.apellidoPat} ${item.apellidoMat}?`;
      this.showDlgConfirmar = true;
    },

    async onConfirmar(value) {
      this.showDlgConfirmar = false;
      if (value === true) {
        this.overlay = true;
        try {
          await serv.quitarMandoAut(this.numEmpDelete);
          this.overlay = false;
          this.loadMandos();
        }catch(error) {
          this.overlay = false;
          this.handleError(error, "No se pudo eliminar el registro.")
        }
      }
    },

    formatFec(fecha) {
      if (!fecha) return ""
      const [year, month, day] = fecha.substr(0,10).split('-');
      return `${day}/${month}/${year}`
    },
  },

  mounted() {
    this.loadMandos();
  }
}
</script>